// extracted by mini-css-extract-plugin
module.exports = {"quote":"NgvXh","iconFirst":"ABTnG","iconSecond":"ZuYbT","quoteText":"SceF4"};